import { UUID } from "@screencloud/uuid";
import { useState } from "react";
import {
  AttachmentInput,
  ContentInput,
  DemoChannelContentType,
} from "src/types.g";

export type FilestackUploadedFile = AttachmentInput & {
  name: string;
};

// Helper function to check if body content is effectively empty
const isBodyEmpty = (bodyContent: string): boolean => {
  return (
    !bodyContent || bodyContent === "<p><br></p>" || bodyContent.trim() === ""
  );
};

export const useCreateQuickPost = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState<FilestackUploadedFile[]>(
    [],
  );
  const [appPlatformData, setAppPlatformData] = useState<{
    appConfigId: UUID;
    hookId: UUID;
    feedId: UUID;
  }>({
    appConfigId: "",
    hookId: "",
    feedId: "",
  });

  const getCreateDemoChannelParams = (): ContentInput => {
    return {
      type: DemoChannelContentType.QuickPost,
      quickPostData: {
        title,
        body,
        appConfigId: appPlatformData.appConfigId,
        hookId: appPlatformData.hookId,
        feedId: appPlatformData.feedId,
        attachments: uploadedFiles.map((file) => ({
          contentType: file.contentType,
          url: file.url,
        })),
      },
    };
  };

  const disableNextButton =
    (!title && isBodyEmpty(body) && uploadedFiles.length === 0) ||
    (!appPlatformData.appConfigId &&
      !appPlatformData.hookId &&
      !appPlatformData.feedId);

  return {
    getCreateDemoChannelParams,
    disableNextButton,
    title,
    body,
    setTitle,
    setBody,
    uploadedFiles,
    setUploadedFiles,
    appPlatformData,
    setAppPlatformData,
  };
};
